<template>
  <BQdtCard
    name="complaintsAnalyticsHelp"
    type="help"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'AnalyticsHelp',

  components: { BQdtCard },
}
</script>
